import type { Response } from "~/types";
import { useLarafetch } from "~/composables/useLarafetch";

export const useGetRequests = () => {
  const { apiVersion } = useRuntimeConfig().public;

  const getCountries = async () =>
    await $larafetch(`/api/${apiVersion}/countries`);

  /**
   * Unused — `useBusiness().getBusiness` is the one every caller reaches for.
   * Kept in step with it so the two cannot drift into behaving differently if
   * something does pick this one up.
   */
  const getBusiness = async (location_identifier: string) => {
    const { data, error } = await useLarafetch(
      `/api/${apiVersion}/${location_identifier}`
    );

    if (error.value) {
      throw error.value;
    }

    return data.value as Response<unknown>;
  };

  const getLocationDetails = async (location_identifier: string) => {
    const { data, error } = await useLarafetch(
      `/api/${apiVersion}/${location_identifier}/details`
    );

    /**
     * `useFetch` reports failures on `error` instead of rejecting, so this used
     * to return an empty `data` and leave the caller's `catch` unreachable.
     */
    if (error.value) {
      throw error.value;
    }

    return data.value as Response<{ cart_count: number }>;
  };

  const getServices = async (location_identifier: string) =>
    await $larafetch(`/api/${apiVersion}/${location_identifier}/services`);

  const getBookings = async (status: string) =>
    await $larafetch(`/api/${apiVersion}/account/my-bookings`, {
      query: {
        status: status,
      },
    });

  const getCreateBusiness = async () =>
    await $larafetch(`/api/${apiVersion}/register-business`);

  const bookingFinished = async <T>(location_identifier: T, reference: T) =>
    await $larafetch(
      `/api/${apiVersion}/${location_identifier}/b-${reference}/finished`
    );

  const confirmBooking = async (location_identifier: string, reference: string) => await $larafetch(`/api/${apiVersion}/${location_identifier}/b-${reference}/confirm`, {
    method: "get"
  });

  return {
    getCountries,
    getBusiness,
    getLocationDetails,
    getServices,
    getBookings,
    getCreateBusiness,
    bookingFinished,
    confirmBooking
  };
};
